import React, { Component } from 'react';
import { connect } from 'react-redux';
import classname from 'classnames';
import TopNav from '../../includes/TopNav.js';
import { Link } from 'react-router-dom';
import { updateTab, updatePopup, updatePopupTab } from '../../../actions/editordashboard';
import { getAdminSubmission, updateAdminSubmissionInput } from '../../../actions/Admin';
import AdminDashboardMenu from './AdminDashboardMenu';
import { getAdminStudentCollection } from '../../../actions/AdminUserCollection';
import { getAdminUser, updateAdminUserInput } from '../../../actions/AdminUser';
import Pager from '../Pager.js';

import moment from 'moment'

var asTO

class AdminUsers extends Component {
  constructor(props) {
      super(props)
  }
  componentDidMount(props){
      console.log("checking this; ");
      this.getAdminStudentCollection();
  }
  getAdminStudentCollection(){
    console.log("checking this; ");
    this.props.dispatch(getAdminStudentCollection());
  }
  updateAdminUserInput(key, status, e){
    this.props.dispatch(updateAdminUserInput(key, e.target.getAttribute('value')))
    this.props.dispatch(updateAdminUserInput('status', status))
    this.getAdminUser()
  }
  updateAdminUserInputI(key, e){
    this.props.dispatch(updateAdminUserInput(key, e.target.value))
    clearTimeout(asTO)
    asTO = setTimeout(() => {
      this.getAdminUser()
    }, 250)
  }
  updatePopup(state){
    this.props.dispatch(updatePopup(state))
  }
  updatePopupTab(index) {
    this.props.dispatch(updatePopupTab(index))
  }
  getNextPage(page) {
    this.props.dispatch(getAdminStudentCollection(page));
  }
  render() {
    var o1 = classname({
      easing: true,
      active: this.props.AdminUser.usersForm.accountType === "student"
    })
    var o2 = classname({
      easing: true,
      active: this.props.AdminUser.usersForm.accountType === "editor" && this.props.AdminUser.usersForm.status == null
    })
    var o3 = classname({
      easing: true,
      active: this.props.AdminUser.usersForm.accountType === "editor" && this.props.AdminUser.usersForm.status == 0
    })
    console.log("<><><><><><><><><><><><>");
    console.log(this.props.AdminUserCollection);
    console.log("<><><><><><><><><><><><>");

    var StudentsList = this.props.AdminUserCollection.students.map((user, i) => {
      if (user.role_status === 1) {
        user.status = "Active"
      } else {
        user.status = "Inactive"
      }
      return(
        <tr key={i}>
          <td><Link to={"/admindashboard/user/" + user.user_id}>{user.email}</Link></td>
          <td>{user.first_name + ' ' + user.last_name}</td>
          <td>{user.major}</td>
          <td>{user.school}</td>
          <td>{user.study_year}</td>
          <td>{user.signup_date}</td>
          <td>{user.status}</td>
          <td><a>Delete</a></td>
        </tr>
      )
    })
    return(
      <div>
        <TopNav />
        <br/><br/>
        <section className="admin-container">
          <AdminDashboardMenu/>
        {/*<div className="options no-spacing">
              <a className={o1} onClick={this.updateAdminUserInput.bind(this, 'accountType', null)} value="student">All Clients</a>
              <a className={o2} onClick={this.updateAdminUserInput.bind(this, 'accountType', null)} value="editor">All Editors</a>
              <a className={o3} onClick={this.updateAdminUserInput.bind(this, 'accountType', 0)} value="editor">Editors Pending</a>
    </div>*/}
          <div className="adminDashboardTabTitle">Students</div>
          <table className="dashboard-paperlist" >
            <tbody>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Major</th>
                <th>School</th>
                <th>Year of Study</th>
                <th>Sign Up Date</th>
                <th>Account Status</th>
                <th>Delete</th>
              </tr>
              {StudentsList}
            </tbody>
          </table>
          <Pager totalCount={this.props.AdminUserCollection.totalStudents} currentPage="1" clickHandler={this.getNextPage.bind(this)} pageSize="20"></Pager>
        </section>
      </div>
    )
  }
}

export default connect( ({Admin, Dashboard, AdminUser, AdminUserCollection}) => ({Admin, Dashboard, AdminUser, AdminUserCollection}) ) (AdminUsers)

// <input type="text" placeholder="Search..." onChange={this.updateAdminUserInputI.bind(this, 'search')} value={this.props.AdminUser.usersForm.search}/>



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminStudents.js